import { render } from "./trainingPlan.vue?vue&type=template&id=73c6caec"
import script from "./trainingPlan.js?vue&type=script&lang=js"
export * from "./trainingPlan.js?vue&type=script&lang=js"

import "./trainingPlan.vue?vue&type=style&index=0&id=73c6caec&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__